import { render, staticRenderFns } from "./Teamee.vue?vue&type=template&id=45c6ac28&scoped=true&"
import script from "./Teamee.vue?vue&type=script&lang=js&"
export * from "./Teamee.vue?vue&type=script&lang=js&"
import style0 from "./Teamee.vue?vue&type=style&index=0&id=45c6ac28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c6ac28",
  null
  
)

export default component.exports